
import page from "~/layouts/testimonial.vue";

export default {
  components: {
    page,
  },

  data() {
    return {
      itemsAdvantage: [
        {
          principal: "Identité graphique",
        },
        {
          principal: "Site web",
        },
        {
          principal: "Référencement",
        },
        {
          principal: "Facebook",
        },
      ],
    };
  },

  head() {
    return {
      title: "Création de site internet pour Institut de beauté | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Spécialisé dans la médecine esthétique à Nancy, Centre de Médecine Esthétique des Glacis, souhaitait une com’ à son image : soignée et professionnelle.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Graphisme, Site web & Référencement",
        },
        {
          hid: "og:description",
          property: "og:description",
          content: "Centre de Médecine Esthétique des Glacis témoigne",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/case-studies/mockup-cmeg.jpeg"),
        // },
      ],
    };
  },
};
